import { PeakModules } from 'common/constants/peakModules';
import {
  useUnredeemFrontDeskServiceMutation,
  useUnredeemLeadServiceMutation,
  useUnredeemMemberServiceMutation,
  useUnredeemPTLeadServiceMutation,
} from '../api/profileService.api';

const useUnredeemService = (module: PeakModules) => {
  const [unredeemFrontDeskService] = useUnredeemFrontDeskServiceMutation();
  const [unredeemLeadService] = useUnredeemLeadServiceMutation();
  const [unredeemMemberService] = useUnredeemMemberServiceMutation();
  const [unredeemPTLeadService] = useUnredeemPTLeadServiceMutation();

  let unredeemService;

  switch (module) {
    case PeakModules.Members:
      unredeemService = unredeemMemberService;
      break;
    case PeakModules.FrontDesk:
      unredeemService = unredeemFrontDeskService;
      break;
    case PeakModules.Crm:
      unredeemService = unredeemLeadService;
      break;
    case PeakModules.PersonalTrainingCrm:
      unredeemService = unredeemPTLeadService;
      break;
    default:
      unredeemService = null;
      break;
  }

  return unredeemService;
};

export default useUnredeemService;
